<template>
  <!-- "inverted" puts the text to the right -->
  <a
    href="javascript:;"
    class="frontpage-case-item"
    @click="zoomImage($event)"
    v-on:mouseover="mouseOver"
    v-on:mouseleave="mouseLeave"
    :class="{'inverted': inverted, 'active': isActive}"
  >
    <div class="double">
      <div class="half-screen vh-for-mobile" :class="{'firstPageLoad': firstPageLoad}">
        <div class="half-screen__content">
          <div
            ref="willZoom"
            class="frontpage-case-item__image__transition-box"
            v-observe-visibility="{
                callback: activate,
                intersection: {
                    threshold: .9
                }
            }"
          >
            <responsive-image
              :image="currentCase.info.imageLandscape"
              :image2="currentCase.info.imagePortrait"
            />
          </div>

          <div class="frontpage-case-item__text" @click="zoomImage($event)">
            <split-text :dur="0.9" :lazy="true">
              <h2 slot-scope="{}" class="headline">
                Client:
                <span class="bold">{{ title }}</span>
              </h2>
            </split-text>

            <split-text :dur="1.2" :lazy="true">
              <h1 slot-scope="{}" class="headline">{{ subTitle }}</h1>
            </split-text>

            <split-text :dur="1.5" :lazy="true">
              <p slot-scope="{}" class="sub-title">
                Explore
                <svg
                  x="0px"
                  y="0px"
                  viewBox="150 410 300 70"
                  xml:space="preserve"
                  :class="{'animate': isHovered}"
                >
                  <polygon
                    class="st0"
                    points="435.7,445.5 406.8,416.6 406.8,442.3 162.8,442.3 162.8,448.8 406.8,448.8 406.8,474.5 "
                  />
                </svg>
              </p>
            </split-text>
          </div>
        </div>
      </div>

      <div class="half-screen second" :class="{'firstPageLoad': firstPageLoad}">
        <div class="secondary__image">
          <div class="secondary__image-wrapper lazy" :data-src="secondaryImage"></div>
        </div>
      </div>
    </div>

    <!-- <div class="bgColor"
    :style="{'background-color': bgColor}"></div>-->

    <ZoomImage
      :imageToZoom="image"
      :isInstantiated="initClone"
      :initPosition="clonePosition"
      :targetUrl="url"
    />
  </a>
</template>

<script>
import { mapState } from "vuex";
import LazyLoad from "vanilla-lazyload";
import ZoomImage from "@/components/ZoomImage.vue";
import splitText from "@/components/split-text.vue";
import responsiveImage from "@/components/responsive-image.vue";

export default {
  name: "FrontpageCaseSlide",
  components: {
    ZoomImage,
    splitText,
    responsiveImage
  },
  props: {
    id: Number
  },
  data() {
    return {
      isHovered: false,
      isActive: false,
      initClone: false,
      clonePosition: {}
    };
  },
  computed: mapState({
    firstPageLoad: state => state.isInitPageLoad,
    frontPageCases: state => state.frontPageCases,

    currentCase: function(state) {
      return state.data.cases.find(item => item.id === this.id);
    },
    title: function() {
      return this.currentCase.info.title;
    },
    subTitle: function() {
      return this.currentCase.info.subTitle;
    },
    secondaryImage: function() {
      return this.currentCase.frontpage.secondaryImage;
    },
    inverted: function() {
      return this.currentCase.frontpage.inverted;
    },
    bgColor: function() {
      return this.currentCase.frontpage.bgColor;
    },
    url: function() {
      return this.currentCase.info.url;
    },

    image: function(state) {
      return `url(${
        !state.globals.smallScreen
          ? this.currentCase.info.imageLandscape
          : this.currentCase.info.imagePortrait
      })`;
    }
  }),
  methods: {
    zoomImage() {
      const orgElement = this.$refs.willZoom;
      const orgPos = orgElement.getBoundingClientRect();

      this.initClone = true;

      this.clonePosition = {
        top: `${orgPos.y}px`,
        left: `${orgPos.x}px`,
        width: `${orgPos.width}px`,
        height: `${orgPos.height}px`
      };
    },
    activate(isVisible, entry) {
      if (isVisible) {
        this.isActive = true;
        this.frontPageCases.map(current => {
          if (current.element === this.$el) {
            document.body.style.backgroundColor = this.bgColor;
          }
        });
      } else if (
        !isVisible &&
        entry.boundingClientRect.top > 1 &&
        this.frontPageCases[0].element === this.$el
      ) {
        // Is above all cases
        document.body.style.removeProperty("background-color");
      } else if (
        !isVisible &&
        entry.boundingClientRect.top < 1 &&
        this.frontPageCases[this.frontPageCases.length - 1].element === this.$el
      ) {
        // Is below all cases
        document.body.style.removeProperty("background-color");
      }
    },
    mouseOver() {
      this.isHovered = true;
    },
    mouseLeave() {
      this.isHovered = false;
    }
  },
  mounted() {
    const element = this.$el;
    const bgBlock = this.$el.querySelector(".bgColor");
    this.$store.commit("getFrontpageCases", {
      element,
      bgBlock
    });

    new LazyLoad({
      elements_selector: ".lazy"
    });
  },
  destroyed() {
    document.body.style.removeProperty("background-color");
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

$movement: 5vh;
$duration: 2s;

@keyframes intro {
  0% {
    opacity: 0;
    transform: translateY(#{$movement}) scale(0.98);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes arrowAnimation {
  10% {
    opacity: 0;
    transform: translateX(0%);
  }
  11% {
    transform: translateX(-100%);
  }
}

.frontpage-case-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  align-items: center;

  overflow: hidden;

  width: 100%;

  padding-bottom: 0;
  box-sizing: border-box;

  @media screen and (min-width: 765px) {
    padding-bottom: $margin2-1;
  }

  &__text {
    cursor: pointer;
    width: 100%;
    margin-top: $margin1-4;

    position: absolute;
    bottom: 0;
    padding: $margin1-8;
    box-sizing: border-box;

    @media screen and (min-width: 377px) {
      padding: $margin1-8;
    }

    @media screen and (min-width: 765px) {
      padding: 0;
      position: static;
    }

    @media screen and (min-width: 1025px) {
      width: 75%;
    }

    @media screen and (min-width: 1500px) {
      width: 30em;
    }

    h1 {
      @include typeset(display-3);
      @include typeface(expanded);

      opacity: 0;
      margin-bottom: rem(5);
      text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.05);

      @media screen and (min-width: 769px) {
        margin-bottom: 0;
      }
    }

    h2 {
      @include typeset(body-normal);
      opacity: 0;
      margin: rem(8) 0;
      text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.05);
      letter-spacing: 0.05em;
    }

    .bold {
      font-weight: bold;
    }

    .sub-title {
      @include typeset(body-normal);
      @include typeface(expanded);

      position: relative;
      margin: 0;
      padding-top: 0.4em;

      overflow: hidden;

      @media screen and (min-width: 377px) {
        margin-top: 1rem;
      }
    }

    svg {
      transition: transform 0.6s $ease-in-out;
      transform-origin: left;
      margin-bottom: -0.1em;
      margin-left: 0.5em;
      height: 0.8em;
      fill: currentColor;

      &.animate {
        polygon {
          animation: arrowAnimation 1s forwards $ease-in-out;
        }
      }
    }
  }

  .double {
    display: flex;
    align-items: center;
    justify-content: center;

    box-sizing: border-box;
    padding: 0 $margin1-8;
    width: 100%;
    height: 100%;

    @media screen and (min-width: 440px) {
      width: calc(100% - #{$margin1-1});
      padding: 0;
    }

    @media screen and (min-width: 765px) {
      width: 100%;
    }

    .half-screen {
      transition: opacity $duration ease-in-out, transform $duration ease-in-out;
      opacity: 1;
      transform: translateY(0);
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0;

      box-sizing: border-box;

      width: 100%;
      height: 50vh;
      margin-bottom: $margin1-8;

      @media screen and (min-width: 765px) {
        width: 50%;
        height: auto;
        padding-left: $margin1-2;
      }

      @media screen and (min-width: 1620px) {
        padding-left: $margin1-1;
      }

      &__content {
        width: 100%;
        position: absolute;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;

        @media screen and (min-width: 765px) {
          position: static;
        }
      }

      .frontpage-case-item__image__transition-box {
        overflow: hidden;
        height: 100%;

        @media screen and (min-width: 765px) {
          height: auto;
        }
      }

      &.second {
        justify-content: flex-end;
        padding: 0 $margin1-2 0 $margin1-2 * 1.5;

        display: none;

        @media screen and (min-width: 1620px) {
          padding: 0 $margin1-1 0 $margin1-1 * 1.5;
        }

        @media screen and (min-width: 765px) {
          display: block;
        }

        .secondary__image {
          overflow: hidden;
          width: 100%;
          height: 100%;
          margin: $menu-height 0;
        }

        .secondary__image-wrapper {
          width: 100%;
          height: 50vh;
          padding-bottom: calc(100% * 16 / 12);

          background: center / cover no-repeat;

          cursor: pointer;

          overflow: hidden;

          @media screen and (min-width: 765px) {
            height: auto;
          }
        }
      }
    }
  }

  /*
     * For having the image with the text to the right
     */

  &.inverted {
    .double {
      flex-direction: row-reverse;

      .half-screen {
        padding-right: $margin1-1;
        padding-left: 0;

        @media screen and (max-width: 1620px) {
          padding-right: $margin1-2;
        }

        @media screen and (max-width: 377px) {
          padding: 0;
        }

        &.second {
          padding: 0 $margin1-1 * 1.5 0 $margin1-1;

          @media screen and (max-width: 1620px) {
            padding: 0 $margin1-2 * 1.5 0 $margin1-2;
          }
        }
      }
    }
  }
}

.firstPageLoad {
  opacity: 0 !important;
  transform: translateY(#{$movement}) scale(0.98) !important;
  transition-delay: 2s;
  //animation: $intro-animation;
}
</style>
